import React, { FC } from "react";
import { DotLottie, DotLottieReact, FrameEvent } from "@lottiefiles/dotlottie-react";
import loadingDots from "@/assets/lottie/loading-dots.lottie?url";
import { Flex, Box, Text } from "@chakra-ui/react";
import { useClassroomLayoutStore } from "@/stores/v2/classroomLayoutStore";
import InactiveTileContentLayout from "@/js/components/StudentTile/components/inactiveScreenStates/InactiveTileContentLayout";

const StudentTileConnecting: FC = () => {
	const tileSize = useClassroomLayoutStore((state) => state.tileSize);

	const dotLottieRefCallback = (dotLottie: DotLottie) => {
		// when the student tile animation loads in, the animation causes some weird sizing issues
		// with the lottie animation, manually resize every 15 frames (best results after some trial and error)
		if (dotLottie) {
			dotLottie.addEventListener("frame", (n: FrameEvent) => {
				if (Math.floor(n.currentFrame % 15) === 0) {
					dotLottie.resize();
				}
			});
		}
	};

	return (
		<Flex flexDirection={"column"} align={"center"} height={tileSize !== "sm" ? "100%" : ""}>
			<Box width={54} height={54}>
				<DotLottieReact
					src={loadingDots}
					loop
					style={{ width: "54px", height: "54px" }}
					autoplay
					renderConfig={{ autoResize: true, freezeOnOffscreen: false }}
					dotLottieRefCallback={dotLottieRefCallback}
				/>
			</Box>
			<InactiveTileContentLayout>
				<Text fontWeight={"bold"}>Connecting to student</Text>
				{tileSize !== "sm" && <Text>Screen will appear when they're online and actively using their device.</Text>}
			</InactiveTileContentLayout>
		</Flex>
	);
};

export default StudentTileConnecting;
